import React from 'react'
import PropTypes from 'prop-types'

import { Container, Description, Title, Warning, ButtonsGroup } from './styles'
import Button from '../Button'

function ModalRequireLogin({
  title,
  description,
  counter,
  backButtonAction,
  loginButtonAction,
}) {
  return (
    <Container>
      <div>
        <Title>{title}</Title>
        <Description>{description}</Description>
        <Warning>Você será redirecionado em {counter} segundos.....</Warning>
        <ButtonsGroup>
          <Button size="small" outline onClick={() => backButtonAction()}>
            Voltar
          </Button>
          <Button size="small" onClick={() => loginButtonAction()}>
            Login
          </Button>
        </ButtonsGroup>
      </div>
      <img
        src="/assets/img/celular.svg"
        alt="Avatar Celular"
        width="96px"
        height="212px"
      />
    </Container>
  )
}
ModalRequireLogin.defaultProps = {
  backButtonAction: () => {},
  loginButtonAction: () => {},
}

ModalRequireLogin.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  counter: PropTypes.number.isRequired,
  backButtonAction: PropTypes.func,
  loginButtonAction: PropTypes.func,
}

export default ModalRequireLogin
